import axiosClient, { ApiResponse, axiosCustomError } from "./axiosClient"
import { ILanguage } from "./LanguageService"

export interface ICollectionTranslation {
    collectionId: number | null
    languageId: number
    name: string
    language: ILanguage
}

export interface ICollection {
    id: number | null
    name: string
    thumbnail: string
    orderNumber: number | null
    isUsed: boolean
    placeId: number
    translations: Array<ICollectionTranslation>
}

export default class CollectionService {
    static async listAll(placeId: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Collections/${placeId}/All`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async filter(placeId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Collections/${placeId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async get(placeId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Collections/${placeId}/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async delete(placeId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/Collections/${placeId}/${id}`, {

            })

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async update(placeId: number, id: number, formData: FormData) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/Collections/${placeId}/${id}`, formData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async create(placeId: number, formData: FormData) {
        try {
            const { data } = await axiosClient.post<ApiResponse>(`/api/Collections/${placeId}/Create`, formData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async changeIsUsed(placeId: number, id: number) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/Collections/${placeId}/ChangeIsUsed/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }
}